









import Vue from 'vue';
import commonClient from '../../../common/apis';

export default Vue.extend({
  props: {
    stat: {
      type: Object,
      default: null,
    },
    taskId: {
      type: Number,
    },
  },
  methods: {
    restart() {
      commonClient.setConfirmedTask({
        id: this.taskId,
      });
      this.$emit('restart');
    },
  },
});
